import { render } from "./Close.vue?vue&type=template&id=46d5dcc6"
import script from "./Close.vue?vue&type=script&lang=js"
export * from "./Close.vue?vue&type=script&lang=js"
script.render = render

export default script